import OfferModalComponent from "../components/offer-modal-component";
import {onEscPressModalHandler} from "../on-esc-press-modal-handler";
import {setAskPrice} from "../require/set-ask-price";
import {RenderPosition, remove, render} from "../utils/render";


export const showRespectModal = (text = ``) => {
  const modalElement = document.querySelector(`.js--respectModal`);
  const titleElement = modalElement.querySelector(`.modal__title`);
  titleElement.textContent = text;

  modalElement.classList.add(`modal--show`);
  document.addEventListener(`keydown`, onEscPressModalHandler);

  setTimeout(() => {
    modalElement.classList.remove(`modal--show`);
    document.removeEventListener(`keydown`, onEscPressModalHandler);
  }, 3000);
};


export default class OfferController {
  constructor({itemId, currentCity = ``}) {
    this._itemId = itemId;
    this._currentCity = currentCity;
    this._authComponent = null;

    this._onEscPressModalHandler = this._onEscPressModalHandler.bind(this);
  }

  show() {
    document.querySelector(`body`).classList.add(`overflowHidden`);
    document.addEventListener(`keydown`, this._onEscPressModalHandler);

    this._authComponent = new OfferModalComponent({
      city: this._currentCity,
    });
    render(document.querySelector(`body`), this._authComponent.getElement(), RenderPosition.BEFOREEND);

    this._authComponent.setCloseButtonClickHandler(() => this._remove());
    this._authComponent.setOverlayClickHandler(() => this._remove());
    this._authComponent.setShowClass();

    this._focusInput();

    // //
    const priceElement = this._authComponent.getElement().querySelector(`input[name="price"]`);
    const urlElement = this._authComponent.getElement().querySelector(`input[name="url"]`);
    const emailElement = this._authComponent.getElement().querySelector(`input[name="email"]`);
    const phoneElement = this._authComponent.getElement().querySelector(`input[name="phone"]`);
    const wrapButtonElement = this._authComponent.getElement().querySelector(`.offer__buttonWrap`);
    const errorMessageElement = this._authComponent.getElement().querySelector(`.offer__errorMessage`);
    const offerPriceModalButton = this._authComponent.getElement().querySelector(`.js--offerPriceButton`);

    offerPriceModalButton.addEventListener(`click`, () => {
      wrapButtonElement.dataset.mode = `progress`;
      errorMessageElement.textContent = ``;
      errorMessageElement.dataset.show = `false`;

      const resolveHandler = () => {
        wrapButtonElement.dataset.mode = `button`;
        this._remove();
        showRespectModal(`Спасибо за Ваше обращение!`);
      };

      const rejectHanlder = (textError = ``) => {
        errorMessageElement.textContent = textError;
        errorMessageElement.dataset.show = `true`;
        wrapButtonElement.dataset.mode = `button`;
      };

      setAskPrice(this._itemId, priceElement.value, urlElement.value, emailElement.value, phoneElement.value, resolveHandler, rejectHanlder);
    });
  }

  _focusInput() {
    const firstInput = this._authComponent.getElement().querySelector(`input`);
    if (firstInput) {
      firstInput.focus();
    }
  }

  _remove() {
    this._authComponent.getElement().classList.add(`modal--hide`);
    document.querySelector(`body`).classList.remove(`overflowHidden`);
    document.removeEventListener(`keydown`, this._onEscPressModalHandler);
    setTimeout(() => remove(this._authComponent), 1000);
  }

  _onEscPressModalHandler(evt) {
    if (evt.key === `Escape`) {
      this._remove();
    }
  }

}
